import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import "../styles/faqs.css";
import { SITE_NAME } from "../variables";

function Faqs() {
  const { settings } = useSelector((state) => state.site);
  const [query, setQuery] = useState("");
  const [openSet, setOpenSet] = useState(new Set());

  useEffect(() => {
    document.title = `${SITE_NAME} - FAQs`;
  }, []);

  const faqs = Array.isArray(settings?.faqs) ? settings.faqs : [];

  const filteredFaqs = useMemo(() => {
    if (!query.trim()) return faqs;
    const q = query.toLowerCase();
    return faqs.filter((item) =>
      `${item?.question ?? ""} ${item?.answer ?? ""}`.toLowerCase().includes(q)
    );
  }, [faqs, query]);

  const toggleIndex = (index) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  return (
    <div className="faqs-container">
      <h1 className="faqs-title">Frequently Asked Questions</h1>
      <p className="faqs-subtitle">
        Find quick answers. Search or expand a question below.
      </p>

      <div className="faqs-search">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by question or keywords"
          aria-label="Search FAQs"
        />
      </div>

      <div className="faqs-list">
        {filteredFaqs.length === 0 && (
          <div className="faqs-empty">No questions match your search.</div>
        )}

        {filteredFaqs.map((item, index) => {
          const panelId = `faq-panel-${index}`;
          const headerId = `faq-header-${index}`;
          const isOpen = openSet.has(index);
          return (
            <div
              className={`faq-item${isOpen ? " open" : ""}`}
              key={`${item?.question ?? "faq"}-${index}`}
            >
              <button
                id={headerId}
                className="faq-question-button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggleIndex(index)}
              >
                <span className="faq-question-text">{item?.question}</span>
                <span className="faq-icon" aria-hidden>
                  {isOpen ? "–" : "+"}
                </span>
              </button>
              <div
                id={panelId}
                role="region"
                aria-labelledby={headerId}
                className="faq-answer"
                style={{ display: isOpen ? "block" : "none" }}
              >
                <div
                  className="faq-answer-content"
                  dangerouslySetInnerHTML={{ __html: item?.answer ?? "" }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Faqs;
